<template>
  <div id="totalBox">
    <div class="siteBox">
      <div class="siteList">
        <img src="../../assets/example/gsq.png" class="siteIcon"/>
        <div class="siteContent">
          <div class="siteName">拱墅区行政服务中心</div>
          <div class="siteTip">关于行政单位</div>
          <div class="content">
                      拱墅区行政服务中心位于杭州市拱墅区绍兴路555号，是市民之家。
          </div>
          <div class="content">
                  自深入推进“最多跑一次”以来，中心工作人员、群众办事人员大大增加，停车场154个车位每日承担近2000次车辆，基本满负荷运转。原设计的停车场管理模式已
                  经不能满足需求，经常出现僵尸车无法清理、一车多位无法管理、进出场拥堵无法治理等现象。在引入我司智慧化管理系统，配合电子发票、视频监控、车辆导流、
                  闲时共享、业态引入等举措，大大规范车场停放秩序、提高了车场整体形象、提升了车场的通行效率。
          </div>
        </div>
      </div>
      <div class="siteList">
        <img src="../../assets/example/dhdy.png" class="siteIcon"/>
        <div class="siteContent">
          <div class="siteName">大浒东苑</div>
          <div class="siteTip">关于小区</div>
          <div class="content">
            大浒东苑位于杭州市拱墅区双绍弄的大浒东苑，毗邻迪卡侬、欧尚超市等商超，靠近行知中学、杭州育才中学、浙江省电力职工大学等学校。泊车位十分紧张，周边违章乱停现象时常发生，导致交通堵塞，车位流转速度慢。我司对小区内的道闸升级改造后，实现人车分离，方便小区车辆和人员的进出管理；实现车位实时查看、预约、定位、导航和自动结算，加快车辆进出场速度。实现无现金支付，加速流转，分散出场车流，减少排队，提高车位利用率。
          </div>
        </div>
      </div>
      <div class="siteList">
        <img src="../../assets/example/xhsz.png" class="siteIcon"/>
        <div class="siteContent">
          <div class="siteName">西湖山庄</div>
          <div class="siteTip">关于宾馆</div>
          <div class="content">
                      浙江西湖山庄座落于北山路，紧邻黄龙吐翠、宝石流霞、曲院风荷、岳庙等名胜景点，是省国宾接待中心，隶属于省机关事务管理局。但是，山庄与国内大多数酒店
                      一样没有把信息化建设和改善酒店的经营、管理效率等方面的功效挂起钩来，关于智能化停车方面基本处于“人员+设备”原始管治模式，电马云车利用物联网、移
                      动互联网、大数据、云计算、超声技术、北斗定位技术、区块链技术等新科技来帮助提升酒店的智慧化管理水平，尤其是在智能停车领域的信息化、物联化、智能化
                      建设水平，不仅帮助酒店智能引流用户，帮助各类用户精准找到车位，而且能精益管理酒店的停车需求，降低运营管理成本，提高经济效益、社会效益和环境效益。
          </div>
        </div>
      </div>
      <div class="siteList">
        <img src="../../assets/example/gsds.png" class="siteIcon"/>
        <div class="siteContent">
          <div class="siteName">绍兴国商大厦</div>
          <div class="siteTip">关于商场</div>
          <div class="content">
                     位于绍兴市解放北路449号的国商大厦是集购物、休闲为一体的综合性购物场所。高的车流量和有限的停车位，停车异常困难，加之来来往往的行人，道路变得十分拥挤。
          </div>
          <div class="content">
                     电马云车智慧停车系统打破停车信息壁垒，实时告知车主车场情况引导车主寻找空余车位，大大缓解停车紧张问题，同时电马云车的商超消费与停车优惠技术嫁接，提升了国商大厦的服务水平，提高用户体验满意度。
          </div>
        </div>
      </div>
      <div class="bottomTip">想了解更多成功案例，请联系我们></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Siteexample',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  padding-bottom: 61px;
}
.siteBox{
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  background-color: #fff;
  margin-top: -250px;
  padding: 20px 50px 50px 50px;
  box-shadow:0px 4px 16px 0px rgba(133,147,134,0.4);
}
.siteList{
  display: flex;
  align-items: center;
  height: 420px;
}
.siteIcon{
  width:440px;
  height:320px;
}
.siteContent{
  width: 620px;
  margin-left: 42px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.siteName{
  font-size:24px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:30px;
}
.siteTip{
  margin-top: 15px;
  color: rgba(255, 182, 30, 1);
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}
.content{
  width: 620px;
  font-size:16px;
  color:rgba(117, 117, 117, 1);
  line-height:30px;
}
.bottomTip{
  width: 1100px;
  margin: 0 auto;
  height:60px;
  background:rgba(247,247,247,1);
  font-size:20px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/example/exampleSite.vue